export enum TemplateType {
  QUIZ,
  POLL,
}
